import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchOrderById } from "@/services/ordersApi";
import { useBusiness } from "@hooks/useBusiness";

export function useOrderDetails(orderId) {
  const queryClient = useQueryClient();
  const { businessId, users } = useBusiness();

  return useQuery({
    queryKey: ["order", businessId, orderId],
    queryFn: () => fetchOrderById(businessId, orderId, users),
    enabled: Boolean(businessId && orderId && orderId !== "new"),
    staleTime: 1000 * 60 * 5,
    initialData: () => {
      // Must match the list's key, which is scoped by business and staff count.
      const list = queryClient.getQueryData(["orders", businessId, Object.keys(users).length]);
      if (!Array.isArray(list)) return undefined;
      return list.find((order) => order.id === orderId);
    },
  });
}
